import { render, staticRenderFns } from "./StockMovementDrawer.vue?vue&type=template&id=6b9d22a4"
import script from "./StockMovementDrawer.vue?vue&type=script&lang=js"
export * from "./StockMovementDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports